import { CustomOrderType } from '../../carts/CustomOrderType';
import { DeleteCartEntryResult } from '../../../graphql/cart/deleteCartEntry';
import { createAction } from '@reduxjs/toolkit';

export interface ApiCartDeleteCartEntryRequestedPayload {
  readonly actionId: number;
  readonly customOrderType: CustomOrderType;
  readonly entryId: string;
  readonly parentActionId: number;
}

export const apiCartDeleteCartEntryRequestedType = 'api/cart/deleteCartEntry--requested';
export const apiCartDeleteCartEntryRequested = createAction<ApiCartDeleteCartEntryRequestedPayload>(
  apiCartDeleteCartEntryRequestedType
);

export type ApiCartDeleteCartEntryRequestedAction = ReturnType<
  typeof apiCartDeleteCartEntryRequested
>;

export interface ApiCartDeleteCartEntrySucceededPayload {
  readonly cartId: string | null;
  readonly entryId: string;
  readonly result: DeleteCartEntryResult;
  readonly requestedActionId: number;
  readonly parentActionId: number;
}

export const apiCartDeleteCartEntrySucceededType = 'api/cart/deleteCartEntry--succeeded';

export const apiCartDeleteCartEntrySucceeded = createAction<ApiCartDeleteCartEntrySucceededPayload>(
  apiCartDeleteCartEntrySucceededType
);

export type ApiCartDeleteCartEntrySucceededAction = ReturnType<
  typeof apiCartDeleteCartEntrySucceeded
>;

export interface ApiCartDeleteCartEntryFailedPayload {
  readonly requestedActionId: number;
  readonly parentActionId: number;
}

export const apiCartDeleteCartEntryFailedType = 'api/cart/deleteCartEntry--failed';
export const apiCartDeleteCartEntryFailed = createAction<ApiCartDeleteCartEntryFailedPayload>(
  apiCartDeleteCartEntryFailedType
);
export type ApiCartDeleteCartEntryFailedAction = ReturnType<typeof apiCartDeleteCartEntryFailed>;
